<template>
  <v-row class="mb-auto" justify="center">
    <v-col cols="12">
      <search v-if="issearch" :items="headers" @querydata="querydata"></search>
      <v-data-table 
        show-select 
        @toggle-select-all="selectAll" 
        :multi-sort="false" 
        v-model="selected" 
        item-key="Id"
        :headers="headers" 
        :items="mainData" 
        :items-per-page="limit" 
        :options.sync="options"
        :server-items-length="countData" 
        :loading="loading" 
        class="elevation-1 text-no-wrap" 
        show-group-by
        :footer-props="{ 
          itemsPerPageText: '分页:', 
          'items-per-page-options':[10,20,30,50,100,-1]
        }">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>批次</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-btn 
              small 
              :color="issearch ? 'error' : 'success'" 
              dark 
              class="mr-2" 
              @click="issearch = !issearch"
            >
              <v-icon>{{ issearch ? "mdi-magnify-close" : "mdi-magnify" }}</v-icon>
            </v-btn>
            <v-btn small color="warning" dark @click="delselect">
              删除 <v-icon>mdi-checkbox-marked-outline</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="600px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn small color="primary" dark v-bind="attrs" v-on="on">新增</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-form ref="form">
                      <v-row>
                        <v-col cols="12" sm="6">
                          <v-autocomplete 
                            :items="lists1" 
                            :rules="[(v) => !!v || '必填项']" 
                            item-text="Name"
                            item-value="Id" 
                            v-model="editedItem.Producter.Id" 
                            label="产品"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <!-- 修复1：rules 直接传数组，移除扩展运算符 -->
                          <v-text-field 
                            :rules="rules.pici" 
                            validate-on-blur 
                            :error-messages="err_msg_pici" 
                            v-model.trim="editedItem.PiCi" 
                            label="批次号"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-textarea rows="2" label="批次简介" v-model.trim="editedItem.ReMark"></v-textarea>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">取消</v-btn>
                  <v-btn color="blue darken-1" :loading="loading" text @click="save">保存</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.ReMark="{ item }">
          <v-tooltip bottom v-if="item.ReMark&&item.ReMark.length > 17">
            <template v-slot:activator="{ on, attrs }">
              <span 
                v-bind="attrs" 
                v-on="on" 
                style="max-width: 240px;"
                class="d-inline-block text-truncate"
              >{{ item.ReMark }}</span>
            </template>
            <span>{{ item.ReMark }}</span>
          </v-tooltip>
          <span v-else>{{ item.ReMark }}</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon color="info" class="mr-4" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon color="error" @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">刷新数据</v-btn>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import search from "@/components/search";
export default {
  components: {
    search,
  },
  data: function () {
    return {
      // 修复2：rules.pici 改为数组，包含单个校验函数
      rules: {
        pici: [
          (v) => {
            if (!v) return "必填项";
            if (!(v.length >= 2 && v.length <= 50)) return "长度2-50";
            if (!/^[\u4e00-\u9fa5_a-zA-Z0-9\-]+$/.test(v))
              return "字符范围(汉字、_、-、a-z、A-Z、0-9)";
            if (this.editedIndex < 0 || this.mainData[this.editedIndex].PiCi != v) {
              this.$api.isHasPiCi({ PiCi: v }).then((res) => {
                if (res.data) {
                  this.err_msg_pici = ["该批次号已被使用了，请换一个"];
                }
              });
            }
            this.err_msg_pici = [];
            return true;
          }
        ]
      },
      err_msg_pici: [],
      dialog: false,
      selected: [],
      headers: [
        { text: "产品", value: "Producter.Name", groupable: false },
        { text: "批次", value: "PiCi", groupable: false },
        { text: "批次简介", value: "ReMark", groupable: false },
        { text: "操作", value: "actions", sortable: false, groupable: false, width: 105, },
      ],
      issearch: false,
      mainData: [],
      countData: 0,
      offset: 0,
      limit: this.$store.state.glimit,
      query: "",
      exclude: "",
      sortby: "",
      order: "",
      options: {},
      loading: false,
      editedIndex: -1,
      editedItem: {
        Producter: {
          Id: 0
        },
        PiCi: this.$utils.formatDate(new Date(), "yyyyMMddhhmmssS"),
      },
      defaultItem: {
        Producter: {
          Id: 0
        },
        PiCi: this.$utils.formatDate(new Date(), "yyyyMMddhhmmssS"),
      },
      lists1: [],
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "新增" : "编辑";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    options: {
      handler() {
        this.limit = this.options.itemsPerPage;
        this.offset = (this.options.page - 1) * this.limit;
        this.sortby = "";
        this.order = "";
        for (let index = 0; index < this.options.sortBy.length; index++) {
          this.sortby += this.options.sortBy[index] + ",";
          this.order += this.options.sortDesc[index] ? "desc," : "asc,";
        }
        if (this.sortby.length > 0) {
          this.sortby = this.sortby.slice(0, -1);
          this.order = this.order.slice(0, -1);
        }
        this.initialize();
      },
      deep: true,
    },
  },
  methods: {
    querydata(query, exclude) {
      this.query = query;
      this.exclude = exclude;
      this.initialize();
    },
    selectAll(item) {
      this.selected = item.value ? item.items : [];
    },
    delselect(e) {
      if (!confirm("确认删除所有选中项吗?")) return;
      if (this.selected.length > 0) {
        let ids = "";
        let arrid = [];
        for (let index = 0; index < this.selected.length; index++) {
          ids += this.selected[index].Id + ",";
          arrid.push(this.selected[index].Id);
        }
        if (ids.length > 0) {
          ids = ids.slice(0, -1);
        }
        this.loading = true;
        this.$api.delMyPiCi({
          id: ids
        }).then((res) => {
          this.loading = false;
          for (let index = 0; index < arrid.length; index++) {
            this.mainData = this.mainData.filter(
              (item) => item.Id != arrid[index]
            );
          }
          this.countData -= arrid.length;
        }).catch((error) => {
          this.loading = false;
          let message = (error && error.msg) || "删除选中选失败！";
          this.$store.commit("setsnack", { message });
          console.error(error);
        });
      } else {
        this.$store.commit("setsnack", { message: "尚未选择任何项目", color: "warning" });
      }
    },
    initialize() {
      let data = {
        limit: this.limit,
        offset: this.offset,
      };
      if (this.query != "") {
        data.query = this.query;
      }
      if (this.exclude != "") {
        data.exclude = this.exclude;
      }
      if (this.sortby != "") {
        data.sortby = this.sortby;
        data.order = this.order;
      }
      this.loading = true;
      this.$api.getMyPiCis(data).then((res) => {
        this.loading = false;
        if (res.data) {
          this.mainData = res.data;
          this.countData = res.count;
        } else {
          this.mainData = [];
          this.countData = 0;
        }
      }).catch((error) => {
        this.loading = false;
        let message = (error && error.msg) || "获取数据列表失败！";
        this.$store.commit("setsnack", { message });
        console.error(error);
      });
      this.$api.getProducts({
        limit: -1,
        fields: "Id,Name",
        sortby: "Id",
        order: "desc",
      }).then((res) => {
        if (res.data) {
          this.lists1 = res.data;
        } else {
          this.$store.commit("setsnack", { message: '产品列表为空，请先添加产品！' });
          console.warn(res);
          this.$router.push('/product')
        }
      }).catch((error) => {
        let message = (error && error.msg) || "获取选择列表失败！";
        this.$store.commit("setsnack", { message });
        console.error(error);
      });
    },
    editItem(item) {
      this.editedIndex = this.mainData.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      const index = this.mainData.indexOf(item);
      if (confirm("确认删除此项数据吗?")) {
        const data = {
          id: item.Id,
        };
        this.loading = true
        this.$api.delMyPiCi(data).then((res) => {
          this.loading = false
          this.mainData.splice(index, 1);
          this.countData--;
        }).catch((error) => {
          this.loading = false
          let message = (error && error.msg) || "删除失败！";
          this.$store.commit("setsnack", { message });
          console.error(error);
        });
      }
    },
    close() {
      this.dialog = false;
      this.defaultItem.PiCi = this.$utils.formatDate(new Date(), "yyyyMMddhhmmssS")
      this.$nextTick(() => {
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
        this.editedIndex = -1;
      });
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      let data = JSON.parse(JSON.stringify(this.editedItem));

      delete data.CreateAt;
      delete data.UpdateAt;
      delete data.Producter.Name;
      data.Userer = {
        Id: this.$store.state.userInfo.Usersproer.Id
      };
      this.editedItem.UpdateAt = this.$utils.formatDate(
        new Date(),
        "yyyy-MM-dd hh:mm:ss"
      );
      this.editedItem.Producter.Name = this.lists1.filter(
        (item) => item.Id == data.Producter.Id
      )[0].Name;
      if (this.editedIndex > -1) {
        this.$api
          .editMyPiCi(data)
          .then((res) => {
            this.loading = false;
            Object.assign(this.mainData[this.editedIndex], this.editedItem);
            this.close();
          })
          .catch((error) => {
            this.loading = false;
            let message = (error && error.msg) || "编辑失败！";
            this.$store.commit("setsnack", { message });
            console.error(error);
          });
      } else {
        this.$api
          .addMyPiCi(data)
          .then((res) => {
            this.loading = false;
            this.editedItem.Id = res.data;
            this.editedItem.CreateAt = this.editedItem.UpdateAt;
            this.mainData.unshift(this.editedItem);
            this.countData++;
            this.close();
          })
          .catch((error) => {
            this.loading = false;
            let message = (error && error.msg) || "添加失败！";
            this.$store.commit("setsnack", { message });
            console.error(error);
          });
      }
    },
  },
};
</script>